import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled(Chip)`
    margin-left: 8px;
`;

const DraftChip = () => {
    const { t } = useTranslation('admin_settings');

    return (
        <Container
            label={t('draft')}
            size="small"
            aria-label={t('classes.class-status-draft')}
            role="status"
            color="default"
            data-testid="draft-chip"
        />
    );
};

export default DraftChip;
